import FilterCard from 'components/FilterCard/startСomponent/FilterCard'
import React from 'react'
import { useFilterCardRemote } from 'components/FilterCard/hooks/useFilterCardRemote'

const FilterCardRemote = ({ onChange, value = [], listQuery, queryVariables, label, allItemsLabel, height, clearValueFromParent, labelStyles, startAllInactive, withSearch }) => {
	const {
		handleSave,
		handleAllActiveClick,
		handleClick,
		showModal,
		setShowModal,
		methods,
		columns
	} = useFilterCardRemote(value, onChange, clearValueFromParent, startAllInactive)
	return <FilterCard methods={methods} listQuery={listQuery} queryVariables={queryVariables} value={value} allItemsLabel={allItemsLabel} height={height} label={label} showModal={showModal} setShowModal={setShowModal} labelStyles={labelStyles} handleClick={handleClick} handleAllActiveClick={handleAllActiveClick} handleSave={handleSave} columns={columns} withSearch={withSearch} />
}

export default FilterCardRemote
